import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface DatePickerReducerState {
  /**
   * Whether the date picker bottom sheet is open.
   */
  open: boolean;
  /**
   * Start date, date *only* unaware of time or timezone, eg: 2024-01-31
   */
  endDate: string | null;
  /**
   * End date, date *only* unaware of time or timezone, eg: 2024-01-31
   */
  startDate: string | null;
}

const initialState: DatePickerReducerState = {
  open: false,
  endDate: null,
  startDate: null,
};

export const datePickerSlice = createSlice({
  name: "datePicker",
  initialState,
  reducers: {
    setDatePickerDateRangeAction: (
      state: DatePickerReducerState,
      action: PayloadAction<{
        // use date string without time, eg: "2024-01-31"
        startDate: string | null;
        endDate: string | null;
      }>,
    ) => {
      const { startDate, endDate } = action.payload;
      if (startDate === state.startDate && endDate === state.endDate) {
        return;
      }

      state.startDate = startDate;
      state.endDate = endDate;
    },
  },
});

export const selectDatePickerStartDate = (state: RootState) => {
  return state.datePicker?.startDate ?? null;
};

export const selectDatePickerEndDate = (state: RootState) => {
  return state.datePicker?.endDate ?? null;
};

type DatePickerDateRange = {
  startDate: string | null;
  endDate: string | null;
};

export const selectDatePickerDateRange = createSelector(
  selectDatePickerStartDate,
  selectDatePickerEndDate,
  (startDate, endDate): DatePickerDateRange => {
    return {
      startDate,
      endDate,
    };
  },
);

export const selectIsDatePickerOpen = (state: RootState) => {
  return state.datePicker.open;
};

export const { setDatePickerDateRangeAction, setDatePickerOpenAction } =
  datePickerSlice.actions;

// eslint-disable-next-line import/no-default-export
export default datePickerSlice.reducer;
export type { DatePickerReducerState, DatePickerDateRange };
